/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates how summaries are displayed inside groups.
 */
export var GroupSummaryDisplayMode = /*@__PURE__*/ (function (GroupSummaryDisplayMode) {
    /**
     * Group summaries are displayed in a flat list in the spanning group header.
     */
    GroupSummaryDisplayMode[GroupSummaryDisplayMode["List"] = 0] = "List";
    /**
     * The group header is rendered as cells and summary values are rendered inside the cells
     * aligned with their column.
     */
    GroupSummaryDisplayMode[GroupSummaryDisplayMode["Cells"] = 1] = "Cells";
    /**
     * Group summaries are displayed as summary rows at the top of the group.
     */
    GroupSummaryDisplayMode[GroupSummaryDisplayMode["RowTop"] = 2] = "RowTop";
    /**
     * Group summaries are displayed as summary rows at the bottom of the group.
     */
    GroupSummaryDisplayMode[GroupSummaryDisplayMode["RowBottom"] = 3] = "RowBottom";
    /**
     * No summaries are displayed in the group.
     */
    GroupSummaryDisplayMode[GroupSummaryDisplayMode["None"] = 4] = "None";
    return GroupSummaryDisplayMode;
})({});
/**
 * @hidden
 */
export var GroupSummaryDisplayMode_$type = /*@__PURE__*/ markEnum('GroupSummaryDisplayMode', 'List,0|Cells,1|RowTop,2|RowBottom,3|None,4');
//# sourceMappingURL=GroupSummaryDisplayMode.js.map
